var _div, _div2, _div3;
import PropTypes from 'prop-types';
import React from 'react';
import clsx from 'clsx';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function LoadingSpinner(_ref) {
  let {
    className,
    height,
    ...rest
  } = _ref;
  const rootClassName = clsx(className, 'loading-spinner');
  return /*#__PURE__*/_jsxs("div", {
    "data-cmp": "loading-spinner",
    className: rootClassName,
    ...(height && {
      style: {
        height
      }
    }),
    ...rest,
    children: [_div || (_div = /*#__PURE__*/_jsx("div", {
      className: "bounce1"
    })), _div2 || (_div2 = /*#__PURE__*/_jsx("div", {
      className: "bounce2"
    })), _div3 || (_div3 = /*#__PURE__*/_jsx("div", {
      className: "bounce3"
    }))]
  });
}
export default LoadingSpinner;